import { GenericTableRowInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK apps/server/src/API/Table/GenericTableRow.Controller.ts

export class TablesAPI {
  static async getRow(orgId: number, tableId: string, userId: number) {
    return APIService.Server.get<GenericTableRowInterface>(`/generic-table/org/${orgId}/table/${tableId}/user/${userId}`);
  }
  static async upsertRow(orgId: number, tableId: string, row: Partial<GenericTableRowInterface>) {
    return APIService.Server.post<GenericTableRowInterface>(`/generic-table/org/${orgId}/table/${tableId}`, row);
  }
  static async queryTable(orgId: number, tableId: string, startDate: string, endDate: string, constraints: { [key: string]: any }) {
    return APIService.Server.get<GenericTableRowInterface[]>(`/generic-table/org/${orgId}/table/${tableId}/query`, {
      ...constraints,
      startDate,
      endDate,
    });
  }
}
